import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { ClaimService } from '@wsphere/warranties/web';
import { ClaimResolver } from '../../resolver';
import { WarrantyResolver } from '../warranty.resolver';

@Injectable()
export class ClaimGuard implements CanActivate {
  constructor(
    private router: Router,
    private claimSvc: ClaimService,
    private resolver: ClaimResolver,
    private warrantyResolver: WarrantyResolver
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    // Check policy config by using warranty stored in resolver data of parent route
    const selfServeClaims = this.warrantyResolver.warranty?.policy?.customerPortalConfig?.selfServeClaims ?? true;
    if (!selfServeClaims) {
      return this.router.createUrlTree([`/warranty/${this.warrantyResolver.warranty?.contractNumber ?? ''}`]);
    }

    this.resolver.claim = null;

    const claimId = this.findClaimId(route);
    if (!claimId) return false;

    this.resolver.claim = await this.claimSvc.get(claimId);
    if (!this.resolver.claim) return false;

    return true;
  }

  private findClaimId(route: ActivatedRouteSnapshot): string {
    return route.params['claimId'] || (route.parent ? this.findClaimId(route.parent) : null);
  }
}
